import React from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { RefreshCw, Search } from 'lucide-react';

interface PASearchFormProps {
  searchTerm: string;
  onSearchTermChange: (value: string) => void;
  onSearch: () => void;
  onReload: () => void;
  isLoading: boolean;
}

const PASearchForm: React.FC<PASearchFormProps> = ({
  searchTerm,
  onSearchTermChange,
  onSearch,
  onReload,
  isLoading
}) => {
  const handleReload = () => {
    onSearchTermChange('');
    onReload();
  };

  return (
    <div className="flex items-center space-x-4 flex-1" data-testid="pa-search-form-container">
      <div className="flex-1" data-testid="pa-search-input-wrapper">
        <Input
          placeholder="Search by name or email..."
          value={searchTerm}
          onChange={(e) => onSearchTermChange(e.target.value)}
          className="w-full"
          data-testid="pa-search-input"
        />
      </div>

      <div className="flex items-center space-x-2 flex-shrink-0" data-testid="pa-search-buttons-wrapper">
        <Button
          onClick={onSearch}
          disabled={isLoading}
          className="bg-purple-600 hover:bg-purple-700 text-white px-6"
          data-testid="pa-search-button"
        >
          <Search className="h-4 w-4 mr-2" />
          {isLoading ? 'Loading...' : 'Search'}
        </Button>

        <Button
          onClick={handleReload}
          variant="outline"
          aria-label="Reload search results"
          size="icon"
          disabled={isLoading}
          className="text-purple-600 border-purple-600 hover:bg-purple-50"
          data-testid="pa-search-reload-button"
        >
          <RefreshCw className={`h-4 w-4 ${isLoading ? 'animate-spin' : ''}`} />
        </Button>
      </div>
    </div>
  );
};

export default PASearchForm;